import { ReactNode } from "react";
import DetailsFormRow from "./DetailsFormRow";
import { multilineTextTransformEscapeHtml } from "./Helpers/multilineTextTransform";

/** Renders a Bootstrap row for a details form with label and multiline text, sill within one row
 * Technically, it calls DetailsFormRow with the transform function that transforms new lines (both lf and crlf) into br tags.
 */
export default function MultilineDetailsFormRow(props: {
  /** Label to display on the left */
  label: string;
  /** Text to display, new lines (both lf and crlf) will be transformed into br tags.
   * The text is always html-encoded.
   * Null and undefined are considered empty values, an empty string not.
   */
  text: string | null | undefined;
  /** Whether, null / undefined values are replaced with Not specified in the small tag. Default is true. */
  showNotSpecifiedForNull?: boolean;
  /** The element to use to replace null/undefined value. The defalut is a small tag with the "not specified" text .*/
  nullReplacementElement?: ReactNode;
}) {
  return (
    <DetailsFormRow
      label={props.label}
      value={props.text}
      showNotSpecifiedForNull={props.showNotSpecifiedForNull}
      transform={multilineTextTransformEscapeHtml}
      displayAsHtml={true}
      nullReplacementElement={props.nullReplacementElement}
    ></DetailsFormRow>
  );
}
